// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"table_tableWrapper__1SNCc","headerWrapper":"table_headerWrapper__3C6dH","bodyWrapper":"table_bodyWrapper__1n9d3"};